import { component } from "picoapp";
import { each } from "lodash-es";
import $ from "jquery";
import axios from "axios";
import Variants from "@shopify/theme-variants";
import { imageSize, preload, getSizedImageUrl } from "@shopify/theme-images";
import { formatMoney } from "@shopify/theme-currency";
import jump from "jump.js";
const delegate = require("delegate");

const selectors = {
  addToCart: "[data-add-to-cart]",
  addToCartText: "[data-add-to-cart-text]",
  comparePrice: "[data-compare-price]",
  comparePriceText: "[data-compare-text]",
  originalSelectorId: "[data-product-select]",
  qtyInputSelector: ".quantity-input-set input",
  priceWrapper: "[data-price-wrapper]",
  productFeaturedImage: "[data-product-featured-image]",
  productJson: "[data-product-json]",
  productPrice: "[data-product-price]",
  productThumbs: "[data-product-single-thumbnail]",
  variantSelectorsUI: "[data-product-variant-selector-ui]",
  singleOptionSelector: "[data-single-option-selector]",
};

class ProductForm {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.init(el);
    this.bindEvents();
    this.updateVariantsAvailability = this.updateVariantsAvailability.bind(
      this
    );
  }

  init(el) {
    // Cache DOM Queries
    this.el = el;
    this.$el = $(el);
    this.productForm = el.querySelector(".Product__form");

    this.variantSelector = el.querySelector(selectors.originalSelectorId);
    this.variantSelectors = el.querySelectorAll(".Product__variantSelector");
    this.qtySelector = el.querySelector(selectors.qtyInputSelector);
    this.priceWrapper = el.querySelector(selectors.priceWrapper);
    this.productPrice = el.querySelector(selectors.productPrice);
    this.optionSelectorsUI = this.productForm.querySelectorAll(
      selectors.variantSelectorsUI
    );
    this.addToCart = el.querySelector(selectors.addToCart);
    this.addToCartText = el.querySelector(selectors.addToCartText);
    this.featuredImage = el.querySelector(selectors.productFeaturedImage);
    this.gallery = el.querySelector(".Product__gallery");

    // Get Product Data
    this.productData = JSON.parse(el.querySelector(selectors.productJson).text);

    this.currentVariant = this.variantSelector.value;

    //Check preorder type and get data
    this.preorderType = this.productForm.getAttribute('preorder-type')
    if (this.preorderType == 'variant') {
      this.preorderData = JSON.parse(el.querySelector('[data-variants-preorder-json]').text);
    }

    // Determine post add to cart action
    this.successAction = this.addToCart.dataset.successAction;

    const options = {
      $container: this.$el,
      enableHistoryState: el.dataset.enableHistoryState || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productData,
    };

    this.settings = {};
    this.variants = new Variants(options);

    const optionValues = [[], [], []];
    this.variants.product.variants.map((el) => {
      if (el.option1 && el.available) {
        optionValues[0].push(el.option1);
      }
    });
    this.variants.product.variants.map((el) => {
      if (el.option2 && el.available) {
        optionValues[1].push(el.option2);
      }
    });
    this.variants.product.variants.map((el) => {
      if (el.option3 && el.available) {
        optionValues[2].push(el.option3);
      }
    });
    this.optionValues = optionValues;
    this.updateVariantsAvailability(this.variants.currentVariant);
    this.markUnavailable();
  }

  /**
   * Mark the options that are totally soldout and unavailable on all variants
   */
  markUnavailable() {
    each(this.variantSelectors, (el, index) => {
      const options = el.querySelectorAll(".option");
      each(options, (el) => {
        if (!this.optionValues[index].includes(el.dataset.value)) {
          if (el.nodeName == "OPTION") {
            //el.disabled = true;
            el.classList.add("sold-out");
          } else {
            el.classList.add("sold-out");
            //el.querySelector("input").disabled = true;
          }
        }
      });
    });
  }

  bindEvents() {
    this.el.addEventListener("submit", this.addProductToCart.bind(this));

    // when changing the first option, reset the following
    delegate(
      this.productForm,
      '.Product__variantSelector[data-option-index="1"] input',
      "change",
      (e) => {
        this.resetForm(e);
      },
      false
    );

    delegate(
      this.productForm,
      '.Product__variantSelector[data-option-index="1"] select',
      "change",
      (e) => {
        this.resetForm(e);
      },
      false
    );

    // When variant is changed
    this.$el.on("variantChange", (ev) => {
      //this.updateVariantsAvailability(ev.variant);
      this.updateAddToCartState(ev);
      this.updateGallery(ev);
    });

    // When variant is changed
    this.$el.on("variantPriceChange", (ev) => {
      this.updateProductPrices(ev);
    });
  }

  updateVariantsAvailability(selectedVariant) {
    if (!selectedVariant) {
      // reset unavailables
      const selectors = document.querySelectorAll(
        ".Product__variantSelector .is-unavailable"
      );
      each(selectors, (el) => {
        el.classList.remove("is-unavailable");
      });
      return;
    }

    let optionsSize = this.productData.options.length;
    let productVariants = this.variants.product.variants;
    let filteredOptionValues = [];

    if (optionsSize > 1) {
      let secondFilter = productVariants
        .filter((variant) => {
          return (
            variant.option1 == selectedVariant.option1 && variant.available
          );
        })
        .map((variant) => {
          return variant.option2;
        });
      filteredOptionValues.push([...new Set(secondFilter)]);
    }

    if (optionsSize > 2) {
      let thirdFilter = productVariants
        .filter((variant) => {
          return (
            variant.option1 == selectedVariant.option1 &&
            variant.option2 == selectedVariant.option2 &&
            variant.available
          );
        })
        .map((variant) => {
          return variant.option3;
        });
      filteredOptionValues.push([...new Set(thirdFilter)]);
    }

    /**
     * Exclude the first selector DOM element
     * from the list we will be updating
     */
    const [firstOption, ...optionsToUpdate] = this.optionSelectorsUI;

    /**
     * Loop through available options array, and update the UI
     * to match the available options
     */
    optionsToUpdate.forEach((group, index) => {
      let variantGroupOptions = group.querySelectorAll(".option");
      variantGroupOptions.forEach((element) => {
        if (filteredOptionValues[index].includes(element.dataset.value)) {
          element.classList.remove("is-unavailable");
          element.disabled = false;
        } else {
          element.classList.add("is-unavailable");
          element.disabled = true;
        }
      });
    });
  }

  resetForm(e) {
    let productVariants = this.variants.product.variants;
    const level2inputs = this.productForm.querySelectorAll(
      '.Product__variantSelector[data-option-index="2"] input'
    );
    const level3inputs = this.productForm.querySelectorAll(
      '.Product__variantSelector[data-option-index="3"] input'
    );

    const level2selects = this.productForm.querySelectorAll(
      '.Product__variantSelector[data-option-index="2"] select'
    );
    const level3selects = this.productForm.querySelectorAll(
      '.Product__variantSelector[data-option-index="3"] select'
    );
    const options2 = [];
    const options3 = [];

    each(productVariants, (prod) => {
      if (prod.option1 == e.target.value && prod.available) {
        options2.push(prod.option2);
        options3.push(prod.option3);
      }
    });

    if (level2inputs.length) {
      for (let lvl2 of level2inputs) {
        lvl2.parentNode.classList.remove("is-unavailable");
        lvl2.checked = false;
        if (options2.indexOf(lvl2.value) == -1) {
          lvl2.parentNode.classList.add("is-unavailable");
          lvl2.checked = false;
        }
      }

      this.addToCart.disabled = true;
      this.addToCart.querySelector("span").innerHTML = "Choose Options";

      if (!level3inputs.length) {
        return;
      }

      for (let lvl3 of level3inputs) {
        lvl3.parentNode.classList.remove("is-unavailable");
        lvl3.checked = false;
        if (options3.indexOf(lvl3.value) == -1) {
          lvl3.parentNode.classList.add("is-unavailable");
          lvl3.checked = false;
        }
      }

      this.addToCart.disabled = true;
      this.addToCart.querySelector("span").innerHTML = "Choose Options";
    }

    if (level2selects.length) {
      for (let lvl2 of level2selects[0].options) {
        lvl2.disabled = false;
        if (options2.indexOf(lvl2.value) == -1) {
          lvl2.disabled = true;
        }
      }

      this.productForm.querySelector(
        '.Product__variantSelector[data-option-index="2"] select option:not([disabled])'
      ).selected = true;
      level2selects[0].dispatchEvent(new Event("change"));

      if (!level3selects.length) {
        return;
      }

      for (let lvl3 of level3selects[0].options) {
        lvl3.disabled = false;
        if (options3.indexOf(lvl3.value) == -1) {
          lvl3.disabled = true;
        }
      }

      this.productForm.querySelector(
        '.Product__variantSelector[data-option-index="3"] select option:not([disabled])'
      ).selected = true;
      level3selects[0].dispatchEvent(new Event("change"));
    }
  }

  /* resetForm() {
    const level2inputs = this.productForm.querySelectorAll('.Product__variantSelector[data-option-index="2"] input');
    // Abort if we only have tier 1 options
    if (!level2inputs.length) {
      return;
    }
    each(level2inputs, (el) => {
      el.checked = false;
    });
    const level3inputs = this.productForm.querySelectorAll('.Product__variantSelector[data-option-index="3"] input');
    each(level3inputs, (el) => {
      el.checked = false;
    });
    
    this.addToCart.disabled = true;
    this.addToCart.querySelector('span').innerHTML = 'Choose Options';
  } */
  /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabled - Decides whether cart is enabled or disabled
   * @param {string} text - Updates the text notification content of the cart
   */
  updateAddToCartState(evt) {
    const variant = evt.variant;
    if (variant) {
      this.currentVariant = variant.id;
      this.priceWrapper?.classList.remove("hide");
    } else {
      this.addToCart.disabled = true;
      this.addToCartText.innerHTML = theme.strings.unavailable;
      this.priceWrapper?.classList.add("hide");
      return;
    }

    if (variant.available) {
      this.addToCart.disabled = false;
      this.addToCartText.innerHTML = theme.strings.addToCart;
      if (this.preorderType) {
        if (this.preorderType == 'variant') {
          const is_preorder = this.preorderData.find(v => v.id == variant.id).preorder
          if (is_preorder) {
            this.addToCartText.innerHTML = theme.strings.preOrder;
          } else {
            this.addToCartText.innerHTML = theme.strings.addToCart;
          }
        } else {
          this.addToCartText.innerHTML = theme.strings.addToCart;
        }
      }
    } else {
      this.addToCart.disabled = true;
      this.addToCartText.innerHTML = theme.strings.soldOut;
    }
  }
  /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */
  updateProductPrices(evt) {
    const variant = evt.variant;
    const $comparePrice = $(selectors.comparePrice, this.$el);
    const $compareEls = $comparePrice.add(
      selectors.comparePriceText,
      this.$container
    );

    if (this.productPrice) {
      this.productPrice.innerHTML = formatMoney(variant.price, theme.moneyFormat);
    }

    if (variant.compare_at_price > variant.price) {
      $comparePrice.html(
        formatMoney(variant.compare_at_price, theme.moneyFormat)
      );
      $compareEls.removeClass("hide");
    } else {
      $comparePrice.html("");
      $compareEls.addClass("hide");
    }
  }

  updateGallery(evt) {
    const variant = evt.variant;
    if (variant && this.gallery) {
      const variantUpdated = new CustomEvent("variant-updated", {
        detail: {
          variant: variant,
        },
      });
      this.gallery.dispatchEvent(variantUpdated);
    }
  }

  addProductToCart(ev) {
    ev.preventDefault();

    const addingToCart = new CustomEvent("cart.productAdding");
    document.body.dispatchEvent(addingToCart);
    const formData = new FormData(this.productForm);
    axios
      .post("/cart/add.js", formData)
      /* .post("/cart/add.js", {
        quantity: this.qtySelector.value,
        id: this.currentVariant,
      }) */
      .then((response) => {
        const productAddedToCart = new CustomEvent("cart.productAdded", {
          detail: response.data,
        });
        // Redirect to checkout depending on element dataset properties
        if (this.successAction && this.successAction == "redirect") {
          window.location.href = window.location.origin + "/checkout";
        } else {
          document.body.dispatchEvent(productAddedToCart);
          jump(document.body, {
            duration: 600,
            offset: -200,
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
}

export default component((node, ctx) => {
  new ProductForm(node, ctx);
});
// export default ProductForm;
